import { RoleStatus } from "../../types/enums";
import { Stack, Typography } from "@mui/material";

export const RoleTooltip = ({
  tooltip,
  activeStatus,
}: {
  tooltip?: string;
  activeStatus?: RoleStatus;
}) => {
  const disabled = "Disabled due to the company size or on the campaign level.";
  const exclude = "This role is not applicable to companies of this size.";

  return (
    <Stack gap="18px" maxWidth="186px">
      {activeStatus && activeStatus !== RoleStatus.active && (
        <Typography variant="body2" color="white" fontWeight={500}>
          {activeStatus === RoleStatus.disabled ? disabled : exclude}
        </Typography>
      )}

      <Typography variant="body2" color="white">
        {tooltip}
      </Typography>
    </Stack>
  );
};
